(function($){

    // var mq = window.matchMedia("(min-width: 992px)");
    // // mobiles

    // $('.nav').on('click', '.nav__list', function(){
    //     if ( mq.matches ) {
    //         $('.nav__submenu').removeClass('nav__submenu--active')
    //         $(this).find('.nav__submenu').addClass('nav__submenu--active');
    //     } 
    //     // else {
    //     //     $(this).toggleClass('active');
    //     // }
    // });

    // $(document).on('click', function (e) {
    //     if( $(e.target).closest('.nav').length ) return;

    //     $('.main-nav > li').removeClass('active');
    // });

    $(".nav__name").click(function(event) {
        if(!$(this).hasClass('click-allow')) {
            event.preventDefault();
        }
    });


    $(".nav__item").click(function(event) {
        // event.preventDefault();
        //$('.nav__submenu').removeClass('nav__submenu--active');
       // $(this).find('.nav__submenu').addClass('nav__submenu--active');
    });

    // $(document).on('click', function(event) {
    //     event.preventDefault();
    //     $('.nav__submenu').removeClass('nav__submenu--active');
    // });

    $(document).on('click', '.nav__button', function(){
        $(this).toggleClass('nav__button--active');
        $(".nav__list").toggleClass('nav__list--open');
    });

}(jQuery));